module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/cleaning-mobile@3x-8e4de2e5ad0fe5f50b4c392a97a66593.jpg";